import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import { AdminLoginPage } from '../pages/AdminLoginPage'
import { UserLoginPage } from '../pages/UserLoginPage'
import { UserCallPage } from '../pages/UserCallPage'
import { DashboardPage } from '../pages/DashboardPage'
import { CallHistoryPage } from '../pages/CallHistoryPage'
import { AccessKeysPage } from '../pages/admin/AccessKeysPage'
import { RecordingsPage } from '../pages/admin/RecordingsPage'
import { AgentLogsPage } from '../pages/admin/AgentLogsPage'
import { ChangelogPage } from '../pages/ChangelogPage'
import { SettingsPage } from '../pages/SettingsPage'
import { StatisticsPageLazy } from '../pages/StatisticsPageLazy'
import { PhonesHeatmapPage } from '../pages/admin/PhonesHeatmapPage'
import { NotFoundPage } from '../pages/NotFoundPage'
import { RequireUserAuth } from '../components/RequireUserAuth'
import { RequireAdminAuth } from '../components/RequireAdminAuth'
import { AuthLayout } from '../components/AuthLayout'

export const routes: RouteObject[] = [
  // Public
  { path: '/', element: <UserLoginPage /> },
  { path: '/staff/login', element: <AdminLoginPage /> },

  // Legacy path redirects — keep old bookmarks working.
  // Use `<Navigate replace/>` so back-button doesn't trap on the redirect.
  { path: '/login', element: <Navigate to="/staff/login" replace /> },
  { path: '/calls', element: <Navigate to="/staff/calls" replace /> },
  { path: '/settings', element: <Navigate to="/staff/settings" replace /> },
  { path: '/users', element: <Navigate to="/staff/access-keys" replace /> },

  // Operator zone
  {
    path: '/app',
    element: (
      <RequireUserAuth>
        <UserCallPage />
      </RequireUserAuth>
    ),
  },

  // Admin zone
  {
    element: (
      <RequireAdminAuth>
        <AuthLayout />
      </RequireAdminAuth>
    ),
    children: [
      { path: '/staff', element: <DashboardPage /> },
      { path: '/staff/calls', element: <CallHistoryPage /> },
      { path: '/staff/recordings', element: <RecordingsPage /> },
      { path: '/staff/agent-logs', element: <AgentLogsPage /> },
      { path: '/staff/statistics', element: <StatisticsPageLazy /> },
      { path: '/staff/heatmap', element: <PhonesHeatmapPage /> },
      { path: '/staff/access-keys', element: <AccessKeysPage /> },
      { path: '/staff/changelog', element: <ChangelogPage /> },
      { path: '/staff/settings', element: <SettingsPage /> },
    ],
  },

  // Catch-all. Unauthenticated, no guard — a 404 should show to anyone,
  // otherwise a wrong URL while logged out would bounce through a login
  // redirect and swallow the "this page doesn't exist" signal entirely.
  { path: '*', element: <NotFoundPage /> },
]
